const LOCALE_CODES = new Set([
  'en',
  'ru',
  'ja',
  'id',
  'ar',
  'cn',
  'de',
  'es',
  'fr',
  'it',
  'kr',
  'nl',
  'pt',
  'tr',
  'zh',
])

/** 归一化 path（去掉 locale 前缀） */
export function normalizeRoutePath(path) {
  const clean = (path || '/').split('?')[0].split('#')[0]
  const parts = clean.split('/').filter(Boolean)
  if (parts.length && LOCALE_CODES.has(parts[0])) {
    parts.shift()
  }
  return parts.length ? `/${parts.join('/')}` : '/'
}

/** 路由 → 页面 SEO i18n 键（description 键名不统一：desc / description） */
export const ROUTE_SEO_MAP = {
  '/': {
    titleKey: 'homePage.meta.title',
    descriptionKey: 'homePage.meta.desc',
    keywordsKey: 'homePage.meta.keywords',
  },
  '/pricing': {
    titleKey: 'price.seo.title',
    descriptionKey: 'price.seo.description',
    keywordsKey: 'price.seo.keywords',
  },
  '/faq': {
    titleKey: 'faq.seo.title',
    descriptionKey: 'faq.seo.description',
    keywordsKey: 'faq.seo.keywords',
  },
  '/talking-photo-ai': {
    titleKey: 'talkingPhotoPage.meta.title',
    descriptionKey: 'talkingPhotoPage.meta.desc',
    keywordsKey: 'talkingPhotoPage.meta.keywords',
  },
  '/ai-image-to-video': {
    titleKey: 'imageToVideoPage.meta.title',
    descriptionKey: 'imageToVideoPage.meta.desc',
    keywordsKey: 'imageToVideoPage.meta.keywords',
  },
  '/voice-cloning': {
    titleKey: 'aiVoiceCloningPage.meta.title',
    descriptionKey: 'aiVoiceCloningPage.meta.desc',
    keywordsKey: 'aiVoiceCloningPage.meta.keywords',
  },
  '/ai-dubbing': {
    titleKey: 'aiDubbingPage.meta.title',
    descriptionKey: 'aiDubbingPage.meta.desc',
    keywordsKey: 'aiDubbingPage.meta.keywords',
  },
  '/talking-cartoon': {
    titleKey: 'talkingCartoonPage.meta.title',
    descriptionKey: 'talkingCartoonPage.meta.desc',
    keywordsKey: 'talkingCartoonPage.meta.keywords',
  },
  '/talking-avatar': {
    titleKey: 'talkingAvatarPage.meta.title',
    descriptionKey: 'talkingAvatarPage.meta.desc',
    keywordsKey: 'talkingAvatarPage.meta.keywords',
  },
  '/talking-animals': {
    titleKey: 'talkingAnimalsPage.meta.title',
    descriptionKey: 'talkingAnimalsPage.meta.desc',
    keywordsKey: 'talkingAnimalsPage.meta.keywords',
  },
  '/ai-avatar-generator': {
    titleKey: 'aiAvatarPage.meta.title',
    descriptionKey: 'aiAvatarPage.meta.desc',
    keywordsKey: 'aiAvatarPage.meta.keywords',
  },
  '/ai-human-generator': {
    titleKey: 'aiHumanPage.meta.title',
    descriptionKey: 'aiHumanPage.meta.desc',
    keywordsKey: 'aiHumanPage.meta.keywords',
  },
  '/product-avatar': {
    titleKey: 'productAvatarPage.meta.title',
    descriptionKey: 'productAvatarPage.meta.desc',
    keywordsKey: 'productAvatarPage.meta.keywords',
  },
  '/ai-image-generator': {
    titleKey: 'aiImagePage.meta.title',
    descriptionKey: 'aiImagePage.meta.desc',
    keywordsKey: 'aiImagePage.meta.keywords',
  },
  '/ai-influencer-generator': {
    titleKey: 'aiInfluencerPage.meta.title',
    descriptionKey: 'aiInfluencerPage.meta.desc',
    keywordsKey: 'aiInfluencerPage.meta.keywords',
  },
  '/ai-baby-podcast': {
    titleKey: 'aiBabyPodcastPage.meta.title',
    descriptionKey: 'aiBabyPodcastPage.meta.desc',
    keywordsKey: 'aiBabyPodcastPage.meta.keywords',
  },
  '/baby-talking': {
    titleKey: 'babyTalkingPage.meta.title',
    descriptionKey: 'babyTalkingPage.meta.desc',
    keywordsKey: 'babyTalkingPage.meta.keywords',
  },
  '/ai-news-anchor': {
    titleKey: 'talkingNewsPage.meta.title',
    descriptionKey: 'talkingNewsPage.meta.desc',
    keywordsKey: 'talkingNewsPage.meta.keywords',
  },
  '/ai-singing-photo': {
    titleKey: 'singingPhotoPage.meta.title',
    descriptionKey: 'singingPhotoPage.meta.desc',
    keywordsKey: 'singingPhotoPage.meta.keywords',
  },
  '/audio-cleaner': {
    titleKey: 'audioCleanerPage.meta.title',
    descriptionKey: 'audioCleanerPage.meta.desc',
    keywordsKey: 'audioCleanerPage.meta.keywords',
  },
  '/audio-enhancer': {
    titleKey: 'audioEnhancerPage.meta.title',
    descriptionKey: 'audioEnhancerPage.meta.desc',
    keywordsKey: 'audioEnhancerPage.meta.keywords',
  },
  '/baby-singing': {
    titleKey: 'babySingingPage.meta.title',
    descriptionKey: 'babySingingPage.meta.desc',
    keywordsKey: 'babySingingPage.meta.keywords',
  },
  '/cartoon-singing': {
    titleKey: 'cartoonSingingPage.meta.title',
    descriptionKey: 'cartoonSingingPage.meta.desc',
    keywordsKey: 'cartoonSingingPage.meta.keywords',
  },
  '/avatar-dialogue': {
    titleKey: 'avatarDialoguePage.meta.title',
    descriptionKey: 'avatarDialoguePage.meta.desc',
    keywordsKey: 'avatarDialoguePage.meta.keywords',
  },
  '/ai-animate-face-lip-sync': {
    titleKey: 'faceAnimatePage.meta.title',
    descriptionKey: 'faceAnimatePage.meta.desc',
    keywordsKey: 'faceAnimatePage.meta.keywords',
  },
  '/account': {
    titleKey: 'account.seo.title',
    descriptionKey: 'account.seo.description',
    keywordsKey: 'account.seo.keywords',
  },
  '/my-creations': {
    titleKey: 'playground.creations.seo.title',
    descriptionKey: 'playground.creations.seo.description',
    keywordsKey: 'playground.creations.seo.keywords',
  },
  '/refer': {
    titleKey: 'refer.seo.title',
    descriptionKey: 'refer.seo.description',
    keywordsKey: 'refer.seo.keywords',
  },
  '/history-lipsync': {
    titleKey: 'historyLipsync.seo.title',
    descriptionKey: 'historyLipsync.seo.description',
    keywordsKey: 'historyLipsync.seo.keywords',
  },
  '/terms': {
    titleKey: 'terms.seo.title',
    descriptionKey: 'terms.seo.description',
    keywordsKey: 'terms.seo.keywords',
  },
  '/privacy-policy': {
    titleKey: 'privacyPolicy.seo.title',
    descriptionKey: 'privacyPolicy.seo.description',
    keywordsKey: 'privacyPolicy.seo.keywords',
  },
}

export function getRouteSeoKeys(normalizedPath) {
  return ROUTE_SEO_MAP[normalizedPath] ?? null
}
